import React from 'react';
import './HeroSection.css';

function HeroSection() {
  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <h1>Wholesale Trading & Online Retail Distribution for Consumer Product Brands</h1>
          <p className="hero-subtitle">
            Northstar Bridge Commerce LLC partners with suppliers, distributors, and brands to source quality consumer products and distribute them through established online retail channels across the United States.
          </p>
          <div className="hero-buttons">
            <button 
              className="button button-primary"
              onClick={() => handleScroll('contact')}
            >
              Supplier Inquiries
            </button>
            <button 
              className="button button-secondary"
              onClick={() => handleScroll('contact')}
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
